import script from "./ASFAdminLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./ASFAdminLogin.vue?vue&type=script&setup=true&lang=js"

import "./ASFAdminLogin.vue?vue&type=style&index=0&id=c19a728e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c19a728e"]])

export default __exports__